<template>
  <tr>
    <th colspan="9" class="kpi-benchmarks-table__section kpi-benchmarks-table__section--pre-purchase-metrics">
      {{ title }}
      <span class="benchmark-anchor" :id="anchor"></span>
    </th>
  </tr>
</template>

<script>
  export default {
    name: 'TableSubHead',
    props: ['title', 'anchor'],
  };
</script>
